<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row">
            <div class="col-3">
              <h2 class="card-title-desc"> Adjusted Stock</h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-6" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <div v-else class="d-flex">
                <date-picker v-model="selectedDate" range class="me-3" placeholder="Select Dates to Generate Report"></date-picker>
                <button class="btn btn-info me-1 w-100" @click="downloadStockAdjustmentReport">Download Stock Adjustment Report</button>
              </div>
            </div>
          </div>
          <TableLoading v-if="stockAdjustments.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="stockAdjustments.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn"/>
            <b-pagination
                v-model="currentPage"
                :total-rows="stockAdjustments.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {ALL_STOCK_ADJUSTMENTS} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import {mapActions, mapGetters} from "vuex";
import moment from "moment/moment";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {errorToast} from "@/components/successToast";

export default {
  page: {
    title: "Adjusted Stock",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "adjusted-stock",
  data() {
    return {
      title: "Adjusted Stock",
      items: [
        {
          text: "Stock",
          href: routeItems.stock_route
        },
        {
          text: "Adjusted Stock",
          active: true
        }
      ],
      stockAdjustments: {
        page: 0,
        objects: []
      },
      columns:[
        {
          field: 'createdAt',
          label: 'Adjusted Date'
        },
        {
          field: 'productId.productName',
          label: 'Product Name'
        },
        {
          field: 'productId.code',
          label: 'Product Code'
        },
        {
          field: 'initialStockQuantity',
          label: 'Initial Stock Qty'
        },
        {
          field: 'quantity',
          label: 'Quantity Adjusted'
        },
        {
          field: 'newStockQuantity',
          label: 'New Stock Qty'
        },
        {
          field: 'description',
          label: 'Description'
        },
      ],
      selectedDate: "",
      searchKeyword: "",
      currentPage: 1,
      perPage: 30,
    }
  },
  apollo: {
    stockAdjustments: {
      query: ALL_STOCK_ADJUSTMENTS,
      variables(){
        return {
          page: this.currentPage,
          perPage: 30,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    })
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      generateStockAdjustmentReport: 'http/generateStockAdjustmentReport',
    }),
    searchFn(data){
      this.searchKeyword = data
    },
    async downloadStockAdjustmentReport(){
      if (this.selectedDate !== ''){
        const start = moment(this.selectedDate[0]).format('YYYY-MM-DD')
        const end = moment(this.selectedDate[1]).format('YYYY-MM-DD')
        const response = await this.generateStockAdjustmentReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Stock Adjustment ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating stock adjustment report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    }
  }
}
</script>

<style scoped>

</style>
